import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alert",
  templateUrl: "./med-icon-alert.component.html",
})
export class MedIconAlertComponent extends SvgMixinComponent {}
